module.exports = __webpack_public_path__ + "search_dark.b82c46ae416874110495.svg";


//////////////////
// WEBPACK FOOTER
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/assets/modules/dummy-assets/common/img/icon/svg_icon/search_dark.svg
// module id = ../../../../../src/assets/modules/dummy-assets/common/img/icon/svg_icon/search_dark.svg
// module chunks = styles